import { CityEstablishmentRO } from "@routellers/types/dist/city-establishment/city-establishment.ro";
import { CreateCityEstablishmentDto } from "@routellers/types/dist/city-establishment/create-city-establishment.dto";
import {
  CreateEstablishmentFactDto,
  EstablishmentFactCandidateRO,
  UpdateEstablishmentFactDto,
} from "@routellers/types/dist/city-establishment/establishment-fact";
import { UpdateCityEstablishmentDto } from "@routellers/types/dist/city-establishment/update-city-establishment.dto";
import { UpsertCityEstablishmentLocaleDto } from "@routellers/types/dist/city-establishment/upsert-city-establishment-locale.dto";
import { QueryDto } from "@routellers/types/dist/shared/query.dto";
import { QueryRO } from "@routellers/types/dist/shared/query.ro";

import { ApiMethodDeclaration } from "..";

const query: ApiMethodDeclaration<QueryDto, QueryRO<CityEstablishmentRO>> = (
  params,
) => ({
  url: "/admin/city-establishments",
  method: "GET",
  params,
});

const getOne: ApiMethodDeclaration<number, CityEstablishmentRO> = (id) => ({
  url: `/admin/city-establishments/${id}`,
  method: "GET",
});

const create: ApiMethodDeclaration<
  { data: CreateCityEstablishmentDto },
  CityEstablishmentRO
> = ({ data }) => ({
  url: "/admin/city-establishments",
  method: "POST",
  data,
});

const update: ApiMethodDeclaration<
  { id: number; data: UpdateCityEstablishmentDto },
  CityEstablishmentRO
> = ({ id, data }) => ({
  url: `/admin/city-establishments/${id}`,
  method: "PATCH",
  data,
});

const upsertLocale: ApiMethodDeclaration<
  { id: number; data: UpsertCityEstablishmentLocaleDto },
  CityEstablishmentRO
> = ({ id, data }) => ({
  url: `/admin/city-establishments/${id}/locales`,
  method: "PATCH",
  data,
});

const remove: ApiMethodDeclaration<number, { ok: true }> = (id) => ({
  url: `/admin/city-establishments/${id}`,
  method: "DELETE",
});

const listFacts: ApiMethodDeclaration<
  number,
  EstablishmentFactCandidateRO[]
> = (id) => ({
  url: `/admin/city-establishments/${id}/facts`,
  method: "GET",
});

const createFact: ApiMethodDeclaration<
  { id: number; data: CreateEstablishmentFactDto },
  EstablishmentFactCandidateRO
> = ({ id, data }) => ({
  url: `/admin/city-establishments/${id}/facts`,
  method: "POST",
  data,
});

const updateFact: ApiMethodDeclaration<
  { factId: number; data: UpdateEstablishmentFactDto },
  EstablishmentFactCandidateRO
> = ({ factId, data }) => ({
  url: `/admin/city-establishments/facts/${factId}`,
  method: "PATCH",
  data,
});

const removeFact: ApiMethodDeclaration<number, { success: boolean }> = (
  factId,
) => ({
  url: `/admin/city-establishments/facts/${factId}`,
  method: "DELETE",
});

export const cityEstablishmentsApiDeclaration = {
  query,
  getOne,
  create,
  update,
  upsertLocale,
  remove,
  listFacts,
  createFact,
  updateFact,
  removeFact,
};
